
import { api_stuGetStuPwdRemind } from '@/api/javaApi'
const globalCheck = {
    state: {
        checkAccountState: false, // 是否校验
        defaultPassword: ''
    },
    mutations: {
        CHECK_ACCOUNT_STATE(state, data) {
            state.checkAccountState = data
        },
        DEFAULT_PASSWORD(state, data) {
            state.defaultPassword = data;
        }
    },
    actions: {
        methodSetDetaultPassword(store) {
            console.log(store)
            const domain = store.rootState.user.schoolInfo.domain
            store.commit('DEFAULT_PASSWORD', domain + '123456')
        },
        /**
         * 检测密码强度
         * @param {*} store 
         * @param {} params
         * @returns 如果是登录状态
         */
        storeMethodCheckAccount(store, state = true) {
            store.commit('CHECK_ACCOUNT_STATE', false)
            setTimeout(async () => {
                if (Object.keys(store.rootState.user.userInfo).length > 0) {
                    store.commit('CHECK_ACCOUNT_STATE', state)
                }
            }, 500)
        },
        /**
         * 学生端检测是否开启提示
         */
        async storeStuGetStuPwdRemind() {
            const res = await api_stuGetStuPwdRemind()
            return res;
        }
    }
}
export default globalCheck